export default {
  login: {
    phone: '电话号码',
    phoneNumber: '电话号码',
    password: '密码',
    accountNumber: '账号',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    forgotPassword: '忘记密码？',
    contactAdmin: '联系管理员',
    loginButton: '登录',
    register: '注册',
    confirm: '确认',
    changePassword: '更改密码',
    noAccount: '或者还没有账户'
  },
  register: {
    title: '注册',
    verifyOTP: '验证OTP代码',
    registerSuccess: 'Register Success',
    registrationComplete: '您的注册成功了',
    enterPhonePrompt: '请输入您的电话号码',
    next: '下一步',
    back: '返回',
    otpSentTo: 'OTP代码将发送到您的手机',
    phoneNumber: '号码',
    enterOTP: '从您的手机输入OTP代码',
    confirmOTP: '确认OTP',
    resendOTP: '重新发送OTP代码',
    enterPasswordPrompt: '请输入您的密码',
    password: '密码',
    confirmPassword: '确认密码',
    selectBankPrompt: '请选择您的银行',
    selectBank: '选择银行',
    accountNumber: '账号',
    firstName: '名字',
    lastName: '姓氏',
    registerButton: '注册',
    thankYouMessage: '感谢您的注册。您可以使用下面的用户名和密码登录',
    username: '用户名',
    loginButton: '登录',
    or: '或',
    alreadyHaveAccount: '已有账户'
  },
  registerErrors: {
    errorTitle: 'Error!',
    otpTitle: 'OTP!',
    enterOTP: '请输入您收到的OTP代码！',
    invalidOTP: '无效的OTP代码，请重新检查！',
    otpNotFound: '系统中未找到OTP代码，请联系管理员',
    selectBank: '请选择银行！',
    enterAccountNumber: '请输入账号！',
    enterFirstName: '请输入名字！',
    enterLastName: '请输入姓氏！',
    enterPhone: '请输入电话号码！',
    phoneLength: '电话号码必须是10位数字！',
    phoneExists: '此电话号码已注册。如有问题，请联系',
    accountExists: '此账号已注册。如有问题，请联系',
    passwordMinLength: '密码至少需要6个字符！',
    passwordMismatch: '密码不匹配！',
    invalidCredentials: '电话号码/密码不正确！'
  },
  messages: {
    title: '消息！',
    enterPhone: '请输入您的手机号码！',
    enterPassword: '请输入您的密码！',
    invalidCredentials: '电话号码/密码不正确！',
    contactAdminError: '请联系管理员',
    checkPasswordData: '请正确检查您的密码数据！',
    passwordChangedSuccess: '密码更改成功',
    completeAllInfo: '请填写所有信息！',
    enterPhoneAndAccount: '请输入电话号码和账号',
    enterNewPassword: '请输入新密码'
  },
  languages: {
    th: '泰语',
    en: '英语',
    my: '缅甸语',
    ch: '中文'
  },
  main: {
    heroTitle: '精彩活动不断<br>专属优惠超值',
    heroSubtitle: '泰国最多活动，每天陪您尽情娱乐',
    heroCta: '立即注册',
    searchPlaceholder: '搜索游戏或游戏厂商...',
    playButton: '立即游玩',
    titles: {
      favorite: '收藏游戏',
      hot: '热门游戏',
      new: '最新游戏',
      casinoAll: '全部赌场',
      casinoProvider: '赌场 - {name}',
      sport: '体育',
      fishAll: '全部捕鱼游戏',
      fishProvider: '捕鱼游戏 - {name}',
      slotAll: '全部老虎机游戏',
      slotProviders: '老虎机厂商',
      slotProvider: '老虎机游戏 - {name}',
      card: '棋牌游戏'
    }
  },
  header: {
    register: '注册',
    registerNow: '立即注册',
    login: '登录',
    deposit: '存款',
    withdraw: '提款',
    account: '账户',
    nav: {
      slot: 'Slot',
      casino: '赌场',
      sport: '体育',
      privilege: '特权',
      promotion: '促销',
      cashback: '返水',
      continuousDeposit: '连续存款',
      partner: '合作伙伴',
      redeemRewards: '兑换奖励',
      event: '特权',
      continue: '连续存款',
      rewards: '兑换奖励'
    },
    auth: {
      register: '注册',
      login: '登录',
      logout: '登出',
      logoutConfirm: '您想登出吗？'
    },
    loginModal: {
      title: '登录',
      phonePlaceholder: '电话号码',
      passwordPlaceholder: '密码',
      forgotPassword: '忘记密码',
      submit: '登录',
      problem: '遇到问题',
      contactSupport: '联系客户支持'
    },
    registerModal: {
      title: '注册',
      phonePlaceholder: '电话号码',
      confirm: '确认',
      back: '返回'
    },
    otp: {
      message: 'OTP代码将发送到您的手机',
      phoneNumber: '号码',
      placeholder: '从您的手机输入OTP代码',
      confirm: '确认OTP',
      resend: '重新发送OTP代码'
    },
    password: {
      newPlaceholder: '设置密码（6个字符或更多）',
      confirmPlaceholder: '重新输入密码',
      currentPlaceholder: '当前密码',
      new: '新密码',
      confirmNew: '重新输入新密码'
    },
    bank: {
      accountNumberPlaceholder: '输入账号',
      firstnamePlaceholder: '输入名字',
      lastnamePlaceholder: '输入姓氏',
      warning: '请正确填写所有信息，否则您将无法提款'
    },
    registerSuccess: {
      title: '注册成功',
      usernameLabel: 'Username: ',
      passwordLabel: 'Password: '
    },
    depositModal: {
      title: '通过PromptPay存款',
      modalTitle: '存款',
      click: 'Click',
      copy: '复制',
      scbBank: '泰国商业银行',
      ttbBank: 'TMB大城银行',
      kbank: '泰国开泰银行',
      gsbBank: '泰国政府储蓄银行',
      truemoney: 'TrueMoney钱包',
      promptPay: 'PromptPay 存款',
      warning: '请仅使用您注册的账号',
      promotionNotice: '如果您想获得促销，请在转账前点击接受促销',
      generatingInfo: '正在生成 QR Code，请稍候… 请勿关闭此窗口。',
      generatingWarning: '此 QR Code 仅可使用一次，请勿重复扫描！',
      receive: '接受',
      notReceive: '不接受',
      noBonusNotice: '无奖金存款，可立即提款且无附加条件。',
      amountPlaceholder: '请输入存款金额',
      slipReminder: '若 5 分钟内未到账，请在此上传转账凭证！',
      closeButton: '关闭窗口',
      confirm: '确认存款',
      confirmDeposit: '通知存款',
      loading: '正在加载...',
      generatingButton: '正在生成 QR Code...',
      minAmountError: '金额必须大于 {amount} 泰铢',
      depositError: 'PromptPay 存款出现问题',
      contactAdmin: '请联系管理员',
      depositSuccess: 'PromptPay 存款成功',
      qrWarning: '警告：此 QR CODE 只能支付一次。请勿重复交易。重复交易可能导致存款延迟。'
    },
    withdrawModal: {
      modalTitle: '提款',
      amountPlaceholder: '提款金额',
      minimumNotice: '- 最低提款 100 泰铢',
      confirmButton: '确认提款',
      withdrawNotice: '提款通知',
      turnoverComplete: '流水已完成！可提款 {amount} 泰铢。点击确认即可提款。',
      turnoverCompleteSimple: '流水已完成！点击确认即可提款。'
    },
    promotion: {
      title: '促销',
      receive: '接受促销'
    },
    support: {
      customerService: '客户服务',
      service24h: '24小时支持'
    }
  },
  promotionPage: {
    heroTitle: '超强优惠 活动不断<br>此刻最火热的奖励',
    heroSubtitle: '海量游戏加顶级优惠，真正名列第一。',
    heroCta: '立即注册'
  },
  eventPage: {
    heroTitle: '活动不断<br>现在正是福利爆棚',
    heroSubtitle: '海量游戏与专属特权，只有最顶尖才能登场。',
    heroCta: '立即注册',
    alerts: {
      error: 'Error!',
      success: 'Success',
      creditExceeds: '您有超过 4 个积分，无法游玩！',
      creditExceeds10: '您有超过 10 个积分，无法游玩！',
      checkinAlready: '您今天已经签到了。请明天再来！',
      checkinSuccess: '签到成功',
      checkinVerify: '请验证您的签到资格！',
      enterCode: '请输入代码',
      confirm: '确认',
      cancel: '取消',
      codeInvalid: '请检查您的代码！',
      codeAlreadyUsed: '您已经领取过免费代码了！'
    }
  },
  cashbackPage: {
    title: '返水',
    playSummary: '投注汇总',
    deposit: '存款',
    withdraw: '提款',
    totalIncome: '总收益',
    transferButton: '转入主钱包'
  },
  partnerPage: {
    title: '推广链接',
    copy: '复制',
    copyTitle: '复制',
    copySuccess: '复制成功',
    shareHint: '在任何渠道分享您的链接即可开始赚取佣金。',
    earningsTitle: '推广收益',
    levelOne: '直接下线',
    levelTwo: '二级下线',
    levelOneIncome: '直接下线收益',
    levelTwoIncome: '二级下线收益',
    totalIncome: '总收益',
    summaryNote: '*昨日数据汇总',
    table: {
      code: '编号',
      date: '日期',
      deposit: '存款',
      withdraw: '提款'
    },
    levelOneModalTitle: '直接下线',
    levelTwoModalTitle: '二级下线'
  },
  continuePage: {
    title: '连续存款',
    defaultPromotion: '连续存款 7 天',
    bonus: '奖金',
    rulesHtml: '<p style="text-align:center;padding:30px;font-size:16px;">'
      + '<b>• 用户需连续 7 天有存款</b><br>'
      + '✨ 每日累计 999 泰铢 — 赠送 100 泰铢<br>'
      + '✨ 每日累计 1,999 泰铢 — 赠送 200 泰铢<br>'
      + '✨ 每日累计 2,999 泰铢 — 赠送 300 泰铢<br>'
      + '✨ 每日累计 3,999 泰铢 — 赠送 400 泰铢<br>'
      + '✨ 每日累计 4,999 泰铢 — 赠送 500 泰铢<br>'
      + '✨ 每日累计 5,999 泰铢 — 赠送 600 泰铢<br>'
      + '✨ 每日累计 6,999 泰铢 — 赠送 700 泰铢<br>'
      + '✨ 每日累计 7,999 泰铢 — 赠送 800 泰铢<br>'
      + '✨ 每日累计 8,999 泰铢 — 赠送 900 泰铢<br>'
      + '✨ 每日累计 9,999 泰铢 — 赠送 1,000 泰铢<br>'
      + '• 奖金仅限指定的真人/游戏使用<br>'
      + '• 老虎机禁止购买功能（Free Spin）<br>'
      + '• 最多可提款为奖金金额的 3 倍<br>'
      + '• 奖金为额外游戏额度，提款时会被扣除。示例：奖金 100 泰铢，最高可提款 300 泰铢，超出部分将被扣回。<br>'
      + '• 每日 08:00 - 23:45 (GMT+7) 可自动领取<br>'
      + '• 领取前账户余额需低于 10 泰铢'
      + '</p>'
  },
  huayPage: {
    title: '存款条件',
    depositCondition: '**每次存款 300 泰铢或以上即可获得彩票参与资格（仅限开奖日）**',
    rewardText: '猜中奖品可获得 500 积分及 2 倍流水',
    conditionsTitle: '📣 活动参与条件 📣',
    condition1: '1. 最低存款 300 泰铢或以上',
    condition2: '2. 1 张收据可获得 1 次预测权',
    condition3: '3. 可无限次预测 2 位数顶奖',
    condition4: '4. 预测于开奖日 15:00 截止',
    condition5: '5. 需在开奖日 16:00 前完成 1 次流水游玩',
    condition6: '6. 免费积分奖励将在开奖日 19:00 前发放',
    confirmButton: '确认投注彩票',
    loading: 'loading...',
    loadingText: 'loading',
    successMessage: '彩票投注成功 😘',
    checkRightsAlert: '请检查您的投注权限',
    errorMessage: '保存数据时发生错误。请重试',
    okButton: 'OK'
  },
  rouletPage: {
    title: '轮盘免费积分',
    depositCondition: '**每次存款 1000 泰铢或以上即可获得旋转权（仅限周一和周五）**',
    spinButton: '立即旋转',
    spinRights: '旋转权',
    rounds: '次',
    depositPrompt: '每次存款 1000 泰铢或以上即可获得旋转权',
    creditExceeds: '您有超过 4 个积分，无法游玩！',
    noPermissionTitle: '没有轮盘旋转权',
    noPermission: '每次存款 1000 泰铢或以上即可获得旋转权（仅限周一和周五）',
    loseMessage: '很抱歉，本次未中奖',
    winMessage: '恭喜您！获得了',
    credit: '积分',
    coin: '金币',
    okButton: '确定'
  },
  spinPage: {
    title: '转盘免费积分',
    depositCondition: '**每次存款 500 泰铢或以上即可获得旋转权（仅限周一和周五）**',
    spinRights: '旋转权',
    rounds: '轮',
    depositPrompt: '每次存款 500 泰铢或以上即可获得旋转权',
    creditExceeds: '您有超过 4 个积分，无法游玩！',
    noPermissionTitle: '没有转盘旋转权',
    noPermission: '每次存款 500 泰铢或以上即可获得旋转权（仅限周一和周五）',
    winMessage: '您获得了',
    credit: '积分',
    points: 'Points',
    formula: '计算公式',
    hours: '小时',
    okButton: '确定'
  },
  account: {
    info: '账户信息',
    changePassword: '更改密码',
    coupon: '使用优惠券',
    promotion: '已参加促销',
    history: '交易历史'
  },
  common: {
    confirm: '确认',
    back: '返回',
    haveProblem: '遇到问题？',
    contactSupport: '联系客服',
    conditionTitle: '条件',
    conditionMessage: '余额需低于 5 泰铢才能领取此优惠。'
  },
  home: {
    category: {
      jackpot: '大奖游戏',
      popular: '热门游戏',
      new: '新游戏',
      slot: '老虎机游戏',
      liveCasino: '真人赌场',
      review: '客户提款评论'
    },
    game: {
      play: '进入游戏',
      lobby: '进入大厅',
      allGames: '全部游戏',
      gamesCount: '游戏'
    },
    badge: {
      hot: 'Hot',
      new: 'New'
    },
    popular: {
      title: '高频中奖的热门在线老虎机',
      highPayout: '高回报率',
      easyBonus: '简单奖金',
      funGraphics: '有趣的图形和声音',
      playAnytime: '随时随地玩 24/7'
    },
    slot: {
      title: '玩所有游戏供应商 - 无需转账',
      allProviders: '所有游戏供应商可用',
      directWeb: '直接网络服务',
      autoSystem: '自动系统',
      safe: '100% 安全'
    },
    casino: {
      title: '世界级真人赌场！',
      baccarat: '百家乐',
      sicbo: '骰宝',
      dragonTiger: '龙虎',
      poker: '扑克',
      roulette: '轮盘',
      blackjack: '二十一点',
      hilo: 'Hi-Lo',
      bannerTitle: '高级真人赌场',
      bannerSubtitle: '百家乐 | 骰宝 | 龙虎 | 轮盘'
    },
    feature: {
      smartWallet: {
        title: 'Smart Wallet',
        detail: '玩所有游戏<br>无需转账'
      },
      rank: {
        title: '泰国第一',
        detail: '来自世界各地的<br>技术和游戏'
      },
      transaction: {
        title: '快速存款 - 提款',
        detail: '超快速交易<br>使用Bot AI系统'
      },
      everywhere: {
        title: '随处玩',
        detail: '易于使用的系统<br>支持所有设备'
      },
      support: {
        title: '用心服务',
        detail: '客户服务<br>24/7 每天'
      },
      promotion: {
        title: '为您准备的优质促销',
        detail: '泰国各种<br>活动和促销'
      }
    },
    announcement: {
      title: '📢 重要公告',
      noShowAgain: '不再显示此消息',
      acknowledge: '确认'
    }
  },
  rewardsPage: {
    heroTitle: '奖品多多 <br>  随时兑换',
    heroSubtitle: '收集硬币随时兑换所有可用奖品',
    redeemButton: '立即兑换',
    confirmMessage: '您要兑换 {name} 吗?',
    confirmYes: '确认',
    confirmNo: '取消',
    creditRedeemTitle: '兑换积分',
    creditRedeemError: '由于余额超过5泰铢，无法兑换积分'
  },
  historyPage: {
    title: '交易记录',
    dateTime: '日期/时间',
    type: '类型',
    amount: '金额',
    status: '状态',
    types: {
      wheel: '转盘',
      treasureBox: '宝箱',
      roulette: '轮盘',
      checkin: '签到',
      code: '代码',
      scratch: '刮刮卡',
      giftBox: '礼品盒',
      continuousDeposit: '连续存款',
      partner: '合作伙伴',
      cashback: '返现',
      deposit: '存款',
      withdraw: '提款'
    },
    statuses: {
      completed: '已完成',
      cancelled: '已取消',
      pending: '待处理'
    }
  },
  footer: {
    contact: {
      customerService: '客户服务',
      service24h: '24小时支持'
    },
    actions: {
      home: '首页',
      deposit: '存款',
      withdraw: '提款',
      contactUs: '联系我们'
    },
    description: '我们是2024年最大的在线赌场供应商，拥有专家团队的最佳系统开发和改进，他们在整个投注过程中全天候帮助投注者，让您在遇到任何问题时都能充分享受。',
    banks: {
      title: '我们支持的银行'
    },
    partners: {
      title: '我们的合作伙伴'
    },
    autoSystem: '配备快速和现代化的自动存款-提款系统',
    copyright: 'Copyright ©2024, All Rights Reserved. TOKYO789'
  }
}
